import api from '~/store/idonia-api/api'
// import {FakeApiCall} from '~/helpers/fake'

export default {
  idonia: {
    notifications: {
      configuration: {
        get: () => api.getV2('notifications/default-configuration')
      }
    }
  },
  // logged in user
  user: {
    notifications: {
      configuration: {
        get: () => api.getV2('notifications/account-configuration'),
        update: payload => api.putV2('notifications/account-configuration', payload),
        delete: () => api.deleteV2('notifications/account-configuration')
      }
    },
    accesses: payload => api.getV2('account/accesses', payload),
    verify: {
      email: {
        send: () => api.getV2('account/verify/email'),
        check: token => api.putV2('account/verify/email', { data: {token} })
      },
      phone: {
        send: () => api.getV2('account/verify/phone'),
        check: code => api.putV2('account/verify/phone', { data: {code} })
      }
    }
  },
  accounts: {
    account: accountID => ({
      update: payload => api.putV2(`account/${accountID}`, payload)
    }),
    restore: email => api.getV2(`account/restore`, { params: {email} })
  },
  groups: {},
  files: {}
}



// WEBPACK FOOTER //
// ./src/services.js